import { loadable } from '@shared/core/loadableFromNamedExport';

/** Code-split entry for the Cinematic motion type; loads only when Motion resolves on. */
export const LazyCinematic = loadable(() => import(/* webpackChunkName: "content/guest/header/motion/cinematic" */ './Cinematic'), 'Cinematic');
